var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowPortfolio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 43,
    viewBox: "0 0 143 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.515 22.543C143.101 21.9572 143.101 21.0075 142.515 20.4217L132.97 10.8758C132.384 10.29 131.434 10.29 130.848 10.8758C130.262 11.4616 130.262 12.4113 130.848 12.9971L139.334 21.4824L130.848 29.9676C130.262 30.5534 130.262 31.5032 130.848 32.089C131.434 32.6748 132.384 32.6748 132.97 32.089L142.515 22.543ZM24.9997 19.9824C24.1713 19.9824 23.4997 20.6539 23.4997 21.4824C23.4997 22.3108 24.1713 22.9824 24.9997 22.9824L24.9997 19.9824ZM24.9997 22.9824L141.455 22.9824L141.455 19.9824L24.9997 19.9824L24.9997 22.9824Z",
    fill: "#05F2C7",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.515 22.543C120.101 21.9572 120.101 21.0075 119.515 20.4217L109.97 10.8758C109.384 10.29 108.434 10.29 107.848 10.8758C107.262 11.4616 107.262 12.4113 107.848 12.9971L116.334 21.4824L107.848 29.9676C107.262 30.5534 107.262 31.5032 107.848 32.089C108.434 32.6748 109.384 32.6748 109.97 32.089L119.515 22.543ZM1.9997 19.9824C1.17127 19.9824 0.499697 20.6539 0.499697 21.4824C0.499697 22.3108 1.17127 22.9824 1.9997 22.9824L1.9997 19.9824ZM1.9997 22.9824L118.455 22.9824L118.455 19.9824L1.9997 19.9824L1.9997 22.9824Z",
    fill: "#05F2C7",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPortfolio);
export default __webpack_public_path__ + "static/media/arrowPortfolio.3e3fa0815a8bf495504f10c7ab10353d.svg";
export { ForwardRef as ReactComponent };